import Environment from "../common/environment";
import { envType } from "@atlassiansox/analytics-web-client";

export const shouldUseStargate = (): boolean => {
  switch (Environment.getEnvironment()) {
    case "production":
    case "staging":
      return true;
    case "dev":
    default:
      return false;
  }
}

export const getEnvironment = (): string => {
  switch (Environment.getEnvironment()) {
    case "staging": {
      return envType.STAGING;
    }
    case "dev": {
      return envType.DEV;
    }
    case "production":
    default: {
      return envType.PROD;
    }
  }
}